export enum IconType {
    Live,
    Trail,
    RiskLevel,
    DistractionPhone,
    RollingStopAlert,
    FoodDrinkAlert,
    UnbeltedAlert,
    SmokingAlert,
    ObstructionAlert,
    MotionAlert,
    UnspecifiedHeading,
    UnsupportedIcon,
    Violation,
    BreadCrumb,
    TripStart,
    Address,
    EventCollision,
    EventManual,
    EventRecorded,
    EventRisky,
    FollowingDistance,
    GeofenceInEnd,
    GeofenceInStart,
    GeofenceOutEnd,
    GeofenceOutStart,
    GeofenceIcon,
    GeofenceIcon2x,
    GeofenceIcon3x,
    IdleMarker,
    IdleViolation,
    LiveIn,
    LanedepartureMarker,
    LiveOut,
    SpeedingMarker,
    TripEndLeft,
    TripEnd,
    TripStartRight,
    TripStartBlank,
    TripEndBlank,
    Trip,
    Idle,
    Reallystale,
    Stale,
    Stopped,
    Cluster,
    None,
    StoppedIn,
    StoppedOut,
    IdleOut,
    IdleIn,
    LiveLabeled,
    LiveInLabeled,
    LiveOutLabeled,
    IdleLabeled,
    IdleInLabeled,
    IdleOutLabeled,
    StoppedLabeled,
    StoppedInLabeled,
    StoppedOutLabeled,
    StaleLabeled,
    StaleInLabeled,
    StaleOutLabeled,
    ReallystaleLabeled,
    ReallystaleInLabeled,
    ReallystaleOutLabeled,
    CallOut,
    Live_in_0_0,
    Live_in_0_1,
    Live_in_0_2,
    Live_in_0_3,
    Live_in_0_4,
    Live_in_0_5,
    Live_in_0_6,
    Live_in_0_7,
    Live_in_0_8,
    Live_in_0_9,
    Live_in_0_10,
    Live_in_0_11,
    Live_in_0_12,
    Live_in_0_13,
    Live_in_0_14,
    Live_in_0_15,
    Live_in_0_16,
    Live_in_0_17,
    Live_in_0_18,
    Live_in_0_19,
    Live_in_0_20,
    Live_in_0_21,
    Live_in_0_22,
    Live_in_0_23,
    Live_in_0_24,
    Live_in_0_25,
    Live_in_0_26,
    Live_in_0_27,
    Live_in_0_28,
    Live_in_0_29,
    Live_in_0_30,
    Live_in_0_31,
    Live_in_0_32,
    Live_in_0_33,
    Live_in_0_34,
    Live_in_0_35,
    Live_in_1_0,
    Live_in_1_1,
    Live_in_1_2,
    Live_in_1_3,
    Live_in_1_4,
    Live_in_1_5,
    Live_in_1_6,
    Live_in_1_7,
    Live_in_1_8,
    Live_in_1_9,
    Live_in_1_10,
    Live_in_1_11,
    Live_in_1_12,
    Live_in_1_13,
    Live_in_1_14,
    Live_in_1_15,
    Live_in_1_16,
    Live_in_1_17,
    Live_in_1_18,
    Live_in_1_19,
    Live_in_1_20,
    Live_in_1_21,
    Live_in_1_22,
    Live_in_1_23,
    Live_in_1_24,
    Live_in_1_25,
    Live_in_1_26,
    Live_in_1_27,
    Live_in_1_28,
    Live_in_1_29,
    Live_in_1_30,
    Live_in_1_31,
    Live_in_1_32,
    Live_in_1_33,
    Live_in_1_34,
    Live_in_1_35,
    Live_in_2_0,
    Live_in_2_1,
    Live_in_2_2,
    Live_in_2_3,
    Live_in_2_4,
    Live_in_2_5,
    Live_in_2_6,
    Live_in_2_7,
    Live_in_2_8,
    Live_in_2_9,
    Live_in_2_10,
    Live_in_2_11,
    Live_in_2_12,
    Live_in_2_13,
    Live_in_2_14,
    Live_in_2_15,
    Live_in_2_16,
    Live_in_2_17,
    Live_in_2_18,
    Live_in_2_19,
    Live_in_2_20,
    Live_in_2_21,
    Live_in_2_22,
    Live_in_2_23,
    Live_in_2_24,
    Live_in_2_25,
    Live_in_2_26,
    Live_in_2_27,
    Live_in_2_28,
    Live_in_2_29,
    Live_in_2_30,
    Live_in_2_31,
    Live_in_2_32,
    Live_in_2_33,
    Live_in_2_34,
    Live_in_2_35,
    Live_in_3_0,
    Live_in_3_1,
    Live_in_3_2,
    Live_in_3_3,
    Live_in_3_4,
    Live_in_3_5,
    Live_in_3_6,
    Live_in_3_7,
    Live_in_3_8,
    Live_in_3_9,
    Live_in_3_10,
    Live_in_3_11,
    Live_in_3_12,
    Live_in_3_13,
    Live_in_3_14,
    Live_in_3_15,
    Live_in_3_16,
    Live_in_3_17,
    Live_in_3_18,
    Live_in_3_19,
    Live_in_3_20,
    Live_in_3_21,
    Live_in_3_22,
    Live_in_3_23,
    Live_in_3_24,
    Live_in_3_25,
    Live_in_3_26,
    Live_in_3_27,
    Live_in_3_28,
    Live_in_3_29,
    Live_in_3_30,
    Live_in_3_31,
    Live_in_3_32,
    Live_in_3_33,
    Live_in_3_34,
    Live_in_3_35,
    Live_in_4_0,
    Live_in_4_1,
    Live_in_4_2,
    Live_in_4_3,
    Live_in_4_4,
    Live_in_4_5,
    Live_in_4_6,
    Live_in_4_7,
    Live_in_4_8,
    Live_in_4_9,
    Live_in_4_10,
    Live_in_4_11,
    Live_in_4_12,
    Live_in_4_13,
    Live_in_4_14,
    Live_in_4_15,
    Live_in_4_16,
    Live_in_4_17,
    Live_in_4_18,
    Live_in_4_19,
    Live_in_4_20,
    Live_in_4_21,
    Live_in_4_22,
    Live_in_4_23,
    Live_in_4_24,
    Live_in_4_25,
    Live_in_4_26,
    Live_in_4_27,
    Live_in_4_28,
    Live_in_4_29,
    Live_in_4_30,
    Live_in_4_31,
    Live_in_4_32,
    Live_in_4_33,
    Live_in_4_34,
    Live_in_4_35,
    Live_in_5_0,
    Live_in_5_1,
    Live_in_5_2,
    Live_in_5_3,
    Live_in_5_4,
    Live_in_5_5,
    Live_in_5_6,
    Live_in_5_7,
    Live_in_5_8,
    Live_in_5_9,
    Live_in_5_10,
    Live_in_5_11,
    Live_in_5_12,
    Live_in_5_13,
    Live_in_5_14,
    Live_in_5_15,
    Live_in_5_16,
    Live_in_5_17,
    Live_in_5_18,
    Live_in_5_19,
    Live_in_5_20,
    Live_in_5_21,
    Live_in_5_22,
    Live_in_5_23,
    Live_in_5_24,
    Live_in_5_25,
    Live_in_5_26,
    Live_in_5_27,
    Live_in_5_28,
    Live_in_5_29,
    Live_in_5_30,
    Live_in_5_31,
    Live_in_5_32,
    Live_in_5_33,
    Live_in_5_34,
    Live_in_5_35,
    Live_in_6_0,
    Live_in_6_1,
    Live_in_6_2,
    Live_in_6_3,
    Live_in_6_4,
    Live_in_6_5,
    Live_in_6_6,
    Live_in_6_7,
    Live_in_6_8,
    Live_in_6_9,
    Live_in_6_10,
    Live_in_6_11,
    Live_in_6_12,
    Live_in_6_13,
    Live_in_6_14,
    Live_in_6_15,
    Live_in_6_16,
    Live_in_6_17,
    Live_in_6_18,
    Live_in_6_19,
    Live_in_6_20,
    Live_in_6_21,
    Live_in_6_22,
    Live_in_6_23,
    Live_in_6_24,
    Live_in_6_25,
    Live_in_6_26,
    Live_in_6_27,
    Live_in_6_28,
    Live_in_6_29,
    Live_in_6_30,
    Live_in_6_31,
    Live_in_6_32,
    Live_in_6_33,
    Live_in_6_34,
    Live_in_6_35,
    Live_in_7_0,
    Live_in_7_1,
    Live_in_7_2,
    Live_in_7_3,
    Live_in_7_4,
    Live_in_7_5,
    Live_in_7_6,
    Live_in_7_7,
    Live_in_7_8,
    Live_in_7_9,
    Live_in_7_10,
    Live_in_7_11,
    Live_in_7_12,
    Live_in_7_13,
    Live_in_7_14,
    Live_in_7_15,
    Live_in_7_16,
    Live_in_7_17,
    Live_in_7_18,
    Live_in_7_19,
    Live_in_7_20,
    Live_in_7_21,
    Live_in_7_22,
    Live_in_7_23,
    Live_in_7_24,
    Live_in_7_25,
    Live_in_7_26,
    Live_in_7_27,
    Live_in_7_28,
    Live_in_7_29,
    Live_in_7_30,
    Live_in_7_31,
    Live_in_7_32,
    Live_in_7_33,
    Live_in_7_34,
    Live_in_7_35,
    Live_in_8_0,
    Live_in_8_1,
    Live_in_8_2,
    Live_in_8_3,
    Live_in_8_4,
    Live_in_8_5,
    Live_in_8_6,
    Live_in_8_7,
    Live_in_8_8,
    Live_in_8_9,
    Live_in_8_10,
    Live_in_8_11,
    Live_in_8_12,
    Live_in_8_13,
    Live_in_8_14,
    Live_in_8_15,
    Live_in_8_16,
    Live_in_8_17,
    Live_in_8_18,
    Live_in_8_19,
    Live_in_8_20,
    Live_in_8_21,
    Live_in_8_22,
    Live_in_8_23,
    Live_in_8_24,
    Live_in_8_25,
    Live_in_8_26,
    Live_in_8_27,
    Live_in_8_28,
    Live_in_8_29,
    Live_in_8_30,
    Live_in_8_31,
    Live_in_8_32,
    Live_in_8_33,
    Live_in_8_34,
    Live_in_8_35,
    Live_in_9_0,
    Live_in_9_1,
    Live_in_9_2,
    Live_in_9_3,
    Live_in_9_4,
    Live_in_9_5,
    Live_in_9_6,
    Live_in_9_7,
    Live_in_9_8,
    Live_in_9_9,
    Live_in_9_10,
    Live_in_9_11,
    Live_in_9_12,
    Live_in_9_13,
    Live_in_9_14,
    Live_in_9_15,
    Live_in_9_16,
    Live_in_9_17,
    Live_in_9_18,
    Live_in_9_19,
    Live_in_9_20,
    Live_in_9_21,
    Live_in_9_22,
    Live_in_9_23,
    Live_in_9_24,
    Live_in_9_25,
    Live_in_9_26,
    Live_in_9_27,
    Live_in_9_28,
    Live_in_9_29,
    Live_in_9_30,
    Live_in_9_31,
    Live_in_9_32,
    Live_in_9_33,
    Live_in_9_34,
    Live_in_9_35,
    Live_in_10_0,
    Live_in_10_1,
    Live_in_10_2,
    Live_in_10_3,
    Live_in_10_4,
    Live_in_10_5,
    Live_in_10_6,
    Live_in_10_7,
    Live_in_10_8,
    Live_in_10_9,
    Live_in_10_10,
    Live_in_10_11,
    Live_in_10_12,
    Live_in_10_13,
    Live_in_10_14,
    Live_in_10_15,
    Live_in_10_16,
    Live_in_10_17,
    Live_in_10_18,
    Live_in_10_19,
    Live_in_10_20,
    Live_in_10_21,
    Live_in_10_22,
    Live_in_10_23,
    Live_in_10_24,
    Live_in_10_25,
    Live_in_10_26,
    Live_in_10_27,
    Live_in_10_28,
    Live_in_10_29,
    Live_in_10_30,
    Live_in_10_31,
    Live_in_10_32,
    Live_in_10_33,
    Live_in_10_34,
    Live_in_10_35,
    Live_in_11_0,
    Live_in_11_1,
    Live_in_11_2,
    Live_in_11_3,
    Live_in_11_4,
    Live_in_11_5,
    Live_in_11_6,
    Live_in_11_7,
    Live_in_11_8,
    Live_in_11_9,
    Live_in_11_10,
    Live_in_11_11,
    Live_in_11_12,
    Live_in_11_13,
    Live_in_11_14,
    Live_in_11_15,
    Live_in_11_16,
    Live_in_11_17,
    Live_in_11_18,
    Live_in_11_19,
    Live_in_11_20,
    Live_in_11_21,
    Live_in_11_22,
    Live_in_11_23,
    Live_in_11_24,
    Live_in_11_25,
    Live_in_11_26,
    Live_in_11_27,
    Live_in_11_28,
    Live_in_11_29,
    Live_in_11_30,
    Live_in_11_31,
    Live_in_11_32,
    Live_in_11_33,
    Live_in_11_34,
    Live_in_11_35,
    Live_in_12_0,
    Live_in_12_1,
    Live_in_12_2,
    Live_in_12_3,
    Live_in_12_4,
    Live_in_12_5,
    Live_in_12_6,
    Live_in_12_7,
    Live_in_12_8,
    Live_in_12_9,
    Live_in_12_10,
    Live_in_12_11,
    Live_in_12_12,
    Live_in_12_13,
    Live_in_12_14,
    Live_in_12_15,
    Live_in_12_16,
    Live_in_12_17,
    Live_in_12_18,
    Live_in_12_19,
    Live_in_12_20,
    Live_in_12_21,
    Live_in_12_22,
    Live_in_12_23,
    Live_in_12_24,
    Live_in_12_25,
    Live_in_12_26,
    Live_in_12_27,
    Live_in_12_28,
    Live_in_12_29,
    Live_in_12_30,
    Live_in_12_31,
    Live_in_12_32,
    Live_in_12_33,
    Live_in_12_34,
    Live_in_12_35,
    Live_in_13_0,
    Live_in_13_1,
    Live_in_13_2,
    Live_in_13_3,
    Live_in_13_4,
    Live_in_13_5,
    Live_in_13_6,
    Live_in_13_7,
    Live_in_13_8,
    Live_in_13_9,
    Live_in_13_10,
    Live_in_13_11,
    Live_in_13_12,
    Live_in_13_13,
    Live_in_13_14,
    Live_in_13_15,
    Live_in_13_16,
    Live_in_13_17,
    Live_in_13_18,
    Live_in_13_19,
    Live_in_13_20,
    Live_in_13_21,
    Live_in_13_22,
    Live_in_13_23,
    Live_in_13_24,
    Live_in_13_25,
    Live_in_13_26,
    Live_in_13_27,
    Live_in_13_28,
    Live_in_13_29,
    Live_in_13_30,
    Live_in_13_31,
    Live_in_13_32,
    Live_in_13_33,
    Live_in_13_34,
    Live_in_13_35,
    Live_in_14_0,
    Live_in_14_1,
    Live_in_14_2,
    Live_in_14_3,
    Live_in_14_4,
    Live_in_14_5,
    Live_in_14_6,
    Live_in_14_7,
    Live_in_14_8,
    Live_in_14_9,
    Live_in_14_10,
    Live_in_14_11,
    Live_in_14_12,
    Live_in_14_13,
    Live_in_14_14,
    Live_in_14_15,
    Live_in_14_16,
    Live_in_14_17,
    Live_in_14_18,
    Live_in_14_19,
    Live_in_14_20,
    Live_in_14_21,
    Live_in_14_22,
    Live_in_14_23,
    Live_in_14_24,
    Live_in_14_25,
    Live_in_14_26,
    Live_in_14_27,
    Live_in_14_28,
    Live_in_14_29,
    Live_in_14_30,
    Live_in_14_31,
    Live_in_14_32,
    Live_in_14_33,
    Live_in_14_34,
    Live_in_14_35,
    Live_in_15_0,
    Live_in_15_1,
    Live_in_15_2,
    Live_in_15_3,
    Live_in_15_4,
    Live_in_15_5,
    Live_in_15_6,
    Live_in_15_7,
    Live_in_15_8,
    Live_in_15_9,
    Live_in_15_10,
    Live_in_15_11,
    Live_in_15_12,
    Live_in_15_13,
    Live_in_15_14,
    Live_in_15_15,
    Live_in_15_16,
    Live_in_15_17,
    Live_in_15_18,
    Live_in_15_19,
    Live_in_15_20,
    Live_in_15_21,
    Live_in_15_22,
    Live_in_15_23,
    Live_in_15_24,
    Live_in_15_25,
    Live_in_15_26,
    Live_in_15_27,
    Live_in_15_28,
    Live_in_15_29,
    Live_in_15_30,
    Live_in_15_31,
    Live_in_15_32,
    Live_in_15_33,
    Live_in_15_34,
    Live_in_15_35,
    Live_in_16_0,
    Live_in_16_1,
    Live_in_16_2,
    Live_in_16_3,
    Live_in_16_4,
    Live_in_16_5,
    Live_in_16_6,
    Live_in_16_7,
    Live_in_16_8,
    Live_in_16_9,
    Live_in_16_10,
    Live_in_16_11,
    Live_in_16_12,
    Live_in_16_13,
    Live_in_16_14,
    Live_in_16_15,
    Live_in_16_16,
    Live_in_16_17,
    Live_in_16_18,
    Live_in_16_19,
    Live_in_16_20,
    Live_in_16_21,
    Live_in_16_22,
    Live_in_16_23,
    Live_in_16_24,
    Live_in_16_25,
    Live_in_16_26,
    Live_in_16_27,
    Live_in_16_28,
    Live_in_16_29,
    Live_in_16_30,
    Live_in_16_31,
    Live_in_16_32,
    Live_in_16_33,
    Live_in_16_34,
    Live_in_16_35,
    Live_in_17_0,
    Live_in_17_1,
    Live_in_17_2,
    Live_in_17_3,
    Live_in_17_4,
    Live_in_17_5,
    Live_in_17_6,
    Live_in_17_7,
    Live_in_17_8,
    Live_in_17_9,
    Live_in_17_10,
    Live_in_17_11,
    Live_in_17_12,
    Live_in_17_13,
    Live_in_17_14,
    Live_in_17_15,
    Live_in_17_16,
    Live_in_17_17,
    Live_in_17_18,
    Live_in_17_19,
    Live_in_17_20,
    Live_in_17_21,
    Live_in_17_22,
    Live_in_17_23,
    Live_in_17_24,
    Live_in_17_25,
    Live_in_17_26,
    Live_in_17_27,
    Live_in_17_28,
    Live_in_17_29,
    Live_in_17_30,
    Live_in_17_31,
    Live_in_17_32,
    Live_in_17_33,
    Live_in_17_34,
    Live_in_17_35,
    Live_in_18_0,
    Live_in_18_1,
    Live_in_18_2,
    Live_in_18_3,
    Live_in_18_4,
    Live_in_18_5,
    Live_in_18_6,
    Live_in_18_7,
    Live_in_18_8,
    Live_in_18_9,
    Live_in_18_10,
    Live_in_18_11,
    Live_in_18_12,
    Live_in_18_13,
    Live_in_18_14,
    Live_in_18_15,
    Live_in_18_16,
    Live_in_18_17,
    Live_in_18_18,
    Live_in_18_19,
    Live_in_18_20,
    Live_in_18_21,
    Live_in_18_22,
    Live_in_18_23,
    Live_in_18_24,
    Live_in_18_25,
    Live_in_18_26,
    Live_in_18_27,
    Live_in_18_28,
    Live_in_18_29,
    Live_in_18_30,
    Live_in_18_31,
    Live_in_18_32,
    Live_in_18_33,
    Live_in_18_34,
    Live_in_18_35,
    Live_out_0_0,
    Live_out_0_1,
    Live_out_0_2,
    Live_out_0_3,
    Live_out_0_4,
    Live_out_0_5,
    Live_out_0_6,
    Live_out_0_7,
    Live_out_0_8,
    Live_out_0_9,
    Live_out_0_10,
    Live_out_0_11,
    Live_out_0_12,
    Live_out_0_13,
    Live_out_0_14,
    Live_out_0_15,
    Live_out_0_16,
    Live_out_0_17,
    Live_out_0_18,
    Live_out_0_19,
    Live_out_0_20,
    Live_out_0_21,
    Live_out_0_22,
    Live_out_0_23,
    Live_out_0_24,
    Live_out_0_25,
    Live_out_0_26,
    Live_out_0_27,
    Live_out_0_28,
    Live_out_0_29,
    Live_out_0_30,
    Live_out_0_31,
    Live_out_0_32,
    Live_out_0_33,
    Live_out_0_34,
    Live_out_0_35,
    Live_out_1_0,
    Live_out_1_1,
    Live_out_1_2,
    Live_out_1_3,
    Live_out_1_4,
    Live_out_1_5,
    Live_out_1_6,
    Live_out_1_7,
    Live_out_1_8,
    Live_out_1_9,
    Live_out_1_10,
    Live_out_1_11,
    Live_out_1_12,
    Live_out_1_13,
    Live_out_1_14,
    Live_out_1_15,
    Live_out_1_16,
    Live_out_1_17,
    Live_out_1_18,
    Live_out_1_19,
    Live_out_1_20,
    Live_out_1_21,
    Live_out_1_22,
    Live_out_1_23,
    Live_out_1_24,
    Live_out_1_25,
    Live_out_1_26,
    Live_out_1_27,
    Live_out_1_28,
    Live_out_1_29,
    Live_out_1_30,
    Live_out_1_31,
    Live_out_1_32,
    Live_out_1_33,
    Live_out_1_34,
    Live_out_1_35,
    Live_out_2_0,
    Live_out_2_1,
    Live_out_2_2,
    Live_out_2_3,
    Live_out_2_4,
    Live_out_2_5,
    Live_out_2_6,
    Live_out_2_7,
    Live_out_2_8,
    Live_out_2_9,
    Live_out_2_10,
    Live_out_2_11,
    Live_out_2_12,
    Live_out_2_13,
    Live_out_2_14,
    Live_out_2_15,
    Live_out_2_16,
    Live_out_2_17,
    Live_out_2_18,
    Live_out_2_19,
    Live_out_2_20,
    Live_out_2_21,
    Live_out_2_22,
    Live_out_2_23,
    Live_out_2_24,
    Live_out_2_25,
    Live_out_2_26,
    Live_out_2_27,
    Live_out_2_28,
    Live_out_2_29,
    Live_out_2_30,
    Live_out_2_31,
    Live_out_2_32,
    Live_out_2_33,
    Live_out_2_34,
    Live_out_2_35,
    Live_out_3_0,
    Live_out_3_1,
    Live_out_3_2,
    Live_out_3_3,
    Live_out_3_4,
    Live_out_3_5,
    Live_out_3_6,
    Live_out_3_7,
    Live_out_3_8,
    Live_out_3_9,
    Live_out_3_10,
    Live_out_3_11,
    Live_out_3_12,
    Live_out_3_13,
    Live_out_3_14,
    Live_out_3_15,
    Live_out_3_16,
    Live_out_3_17,
    Live_out_3_18,
    Live_out_3_19,
    Live_out_3_20,
    Live_out_3_21,
    Live_out_3_22,
    Live_out_3_23,
    Live_out_3_24,
    Live_out_3_25,
    Live_out_3_26,
    Live_out_3_27,
    Live_out_3_28,
    Live_out_3_29,
    Live_out_3_30,
    Live_out_3_31,
    Live_out_3_32,
    Live_out_3_33,
    Live_out_3_34,
    Live_out_3_35,
    Live_out_4_0,
    Live_out_4_1,
    Live_out_4_2,
    Live_out_4_3,
    Live_out_4_4,
    Live_out_4_5,
    Live_out_4_6,
    Live_out_4_7,
    Live_out_4_8,
    Live_out_4_9,
    Live_out_4_10,
    Live_out_4_11,
    Live_out_4_12,
    Live_out_4_13,
    Live_out_4_14,
    Live_out_4_15,
    Live_out_4_16,
    Live_out_4_17,
    Live_out_4_18,
    Live_out_4_19,
    Live_out_4_20,
    Live_out_4_21,
    Live_out_4_22,
    Live_out_4_23,
    Live_out_4_24,
    Live_out_4_25,
    Live_out_4_26,
    Live_out_4_27,
    Live_out_4_28,
    Live_out_4_29,
    Live_out_4_30,
    Live_out_4_31,
    Live_out_4_32,
    Live_out_4_33,
    Live_out_4_34,
    Live_out_4_35,
    Live_out_5_0,
    Live_out_5_1,
    Live_out_5_2,
    Live_out_5_3,
    Live_out_5_4,
    Live_out_5_5,
    Live_out_5_6,
    Live_out_5_7,
    Live_out_5_8,
    Live_out_5_9,
    Live_out_5_10,
    Live_out_5_11,
    Live_out_5_12,
    Live_out_5_13,
    Live_out_5_14,
    Live_out_5_15,
    Live_out_5_16,
    Live_out_5_17,
    Live_out_5_18,
    Live_out_5_19,
    Live_out_5_20,
    Live_out_5_21,
    Live_out_5_22,
    Live_out_5_23,
    Live_out_5_24,
    Live_out_5_25,
    Live_out_5_26,
    Live_out_5_27,
    Live_out_5_28,
    Live_out_5_29,
    Live_out_5_30,
    Live_out_5_31,
    Live_out_5_32,
    Live_out_5_33,
    Live_out_5_34,
    Live_out_5_35,
    Live_out_6_0,
    Live_out_6_1,
    Live_out_6_2,
    Live_out_6_3,
    Live_out_6_4,
    Live_out_6_5,
    Live_out_6_6,
    Live_out_6_7,
    Live_out_6_8,
    Live_out_6_9,
    Live_out_6_10,
    Live_out_6_11,
    Live_out_6_12,
    Live_out_6_13,
    Live_out_6_14,
    Live_out_6_15,
    Live_out_6_16,
    Live_out_6_17,
    Live_out_6_18,
    Live_out_6_19,
    Live_out_6_20,
    Live_out_6_21,
    Live_out_6_22,
    Live_out_6_23,
    Live_out_6_24,
    Live_out_6_25,
    Live_out_6_26,
    Live_out_6_27,
    Live_out_6_28,
    Live_out_6_29,
    Live_out_6_30,
    Live_out_6_31,
    Live_out_6_32,
    Live_out_6_33,
    Live_out_6_34,
    Live_out_6_35,
    Live_out_7_0,
    Live_out_7_1,
    Live_out_7_2,
    Live_out_7_3,
    Live_out_7_4,
    Live_out_7_5,
    Live_out_7_6,
    Live_out_7_7,
    Live_out_7_8,
    Live_out_7_9,
    Live_out_7_10,
    Live_out_7_11,
    Live_out_7_12,
    Live_out_7_13,
    Live_out_7_14,
    Live_out_7_15,
    Live_out_7_16,
    Live_out_7_17,
    Live_out_7_18,
    Live_out_7_19,
    Live_out_7_20,
    Live_out_7_21,
    Live_out_7_22,
    Live_out_7_23,
    Live_out_7_24,
    Live_out_7_25,
    Live_out_7_26,
    Live_out_7_27,
    Live_out_7_28,
    Live_out_7_29,
    Live_out_7_30,
    Live_out_7_31,
    Live_out_7_32,
    Live_out_7_33,
    Live_out_7_34,
    Live_out_7_35,
    Live_out_8_0,
    Live_out_8_1,
    Live_out_8_2,
    Live_out_8_3,
    Live_out_8_4,
    Live_out_8_5,
    Live_out_8_6,
    Live_out_8_7,
    Live_out_8_8,
    Live_out_8_9,
    Live_out_8_10,
    Live_out_8_11,
    Live_out_8_12,
    Live_out_8_13,
    Live_out_8_14,
    Live_out_8_15,
    Live_out_8_16,
    Live_out_8_17,
    Live_out_8_18,
    Live_out_8_19,
    Live_out_8_20,
    Live_out_8_21,
    Live_out_8_22,
    Live_out_8_23,
    Live_out_8_24,
    Live_out_8_25,
    Live_out_8_26,
    Live_out_8_27,
    Live_out_8_28,
    Live_out_8_29,
    Live_out_8_30,
    Live_out_8_31,
    Live_out_8_32,
    Live_out_8_33,
    Live_out_8_34,
    Live_out_8_35,
    Live_out_9_0,
    Live_out_9_1,
    Live_out_9_2,
    Live_out_9_3,
    Live_out_9_4,
    Live_out_9_5,
    Live_out_9_6,
    Live_out_9_7,
    Live_out_9_8,
    Live_out_9_9,
    Live_out_9_10,
    Live_out_9_11,
    Live_out_9_12,
    Live_out_9_13,
    Live_out_9_14,
    Live_out_9_15,
    Live_out_9_16,
    Live_out_9_17,
    Live_out_9_18,
    Live_out_9_19,
    Live_out_9_20,
    Live_out_9_21,
    Live_out_9_22,
    Live_out_9_23,
    Live_out_9_24,
    Live_out_9_25,
    Live_out_9_26,
    Live_out_9_27,
    Live_out_9_28,
    Live_out_9_29,
    Live_out_9_30,
    Live_out_9_31,
    Live_out_9_32,
    Live_out_9_33,
    Live_out_9_34,
    Live_out_9_35,
    Live_out_10_0,
    Live_out_10_1,
    Live_out_10_2,
    Live_out_10_3,
    Live_out_10_4,
    Live_out_10_5,
    Live_out_10_6,
    Live_out_10_7,
    Live_out_10_8,
    Live_out_10_9,
    Live_out_10_10,
    Live_out_10_11,
    Live_out_10_12,
    Live_out_10_13,
    Live_out_10_14,
    Live_out_10_15,
    Live_out_10_16,
    Live_out_10_17,
    Live_out_10_18,
    Live_out_10_19,
    Live_out_10_20,
    Live_out_10_21,
    Live_out_10_22,
    Live_out_10_23,
    Live_out_10_24,
    Live_out_10_25,
    Live_out_10_26,
    Live_out_10_27,
    Live_out_10_28,
    Live_out_10_29,
    Live_out_10_30,
    Live_out_10_31,
    Live_out_10_32,
    Live_out_10_33,
    Live_out_10_34,
    Live_out_10_35,
    Live_out_11_0,
    Live_out_11_1,
    Live_out_11_2,
    Live_out_11_3,
    Live_out_11_4,
    Live_out_11_5,
    Live_out_11_6,
    Live_out_11_7,
    Live_out_11_8,
    Live_out_11_9,
    Live_out_11_10,
    Live_out_11_11,
    Live_out_11_12,
    Live_out_11_13,
    Live_out_11_14,
    Live_out_11_15,
    Live_out_11_16,
    Live_out_11_17,
    Live_out_11_18,
    Live_out_11_19,
    Live_out_11_20,
    Live_out_11_21,
    Live_out_11_22,
    Live_out_11_23,
    Live_out_11_24,
    Live_out_11_25,
    Live_out_11_26,
    Live_out_11_27,
    Live_out_11_28,
    Live_out_11_29,
    Live_out_11_30,
    Live_out_11_31,
    Live_out_11_32,
    Live_out_11_33,
    Live_out_11_34,
    Live_out_11_35,
    Live_out_12_0,
    Live_out_12_1,
    Live_out_12_2,
    Live_out_12_3,
    Live_out_12_4,
    Live_out_12_5,
    Live_out_12_6,
    Live_out_12_7,
    Live_out_12_8,
    Live_out_12_9,
    Live_out_12_10,
    Live_out_12_11,
    Live_out_12_12,
    Live_out_12_13,
    Live_out_12_14,
    Live_out_12_15,
    Live_out_12_16,
    Live_out_12_17,
    Live_out_12_18,
    Live_out_12_19,
    Live_out_12_20,
    Live_out_12_21,
    Live_out_12_22,
    Live_out_12_23,
    Live_out_12_24,
    Live_out_12_25,
    Live_out_12_26,
    Live_out_12_27,
    Live_out_12_28,
    Live_out_12_29,
    Live_out_12_30,
    Live_out_12_31,
    Live_out_12_32,
    Live_out_12_33,
    Live_out_12_34,
    Live_out_12_35,
    Live_out_13_0,
    Live_out_13_1,
    Live_out_13_2,
    Live_out_13_3,
    Live_out_13_4,
    Live_out_13_5,
    Live_out_13_6,
    Live_out_13_7,
    Live_out_13_8,
    Live_out_13_9,
    Live_out_13_10,
    Live_out_13_11,
    Live_out_13_12,
    Live_out_13_13,
    Live_out_13_14,
    Live_out_13_15,
    Live_out_13_16,
    Live_out_13_17,
    Live_out_13_18,
    Live_out_13_19,
    Live_out_13_20,
    Live_out_13_21,
    Live_out_13_22,
    Live_out_13_23,
    Live_out_13_24,
    Live_out_13_25,
    Live_out_13_26,
    Live_out_13_27,
    Live_out_13_28,
    Live_out_13_29,
    Live_out_13_30,
    Live_out_13_31,
    Live_out_13_32,
    Live_out_13_33,
    Live_out_13_34,
    Live_out_13_35,
    Live_out_14_0,
    Live_out_14_1,
    Live_out_14_2,
    Live_out_14_3,
    Live_out_14_4,
    Live_out_14_5,
    Live_out_14_6,
    Live_out_14_7,
    Live_out_14_8,
    Live_out_14_9,
    Live_out_14_10,
    Live_out_14_11,
    Live_out_14_12,
    Live_out_14_13,
    Live_out_14_14,
    Live_out_14_15,
    Live_out_14_16,
    Live_out_14_17,
    Live_out_14_18,
    Live_out_14_19,
    Live_out_14_20,
    Live_out_14_21,
    Live_out_14_22,
    Live_out_14_23,
    Live_out_14_24,
    Live_out_14_25,
    Live_out_14_26,
    Live_out_14_27,
    Live_out_14_28,
    Live_out_14_29,
    Live_out_14_30,
    Live_out_14_31,
    Live_out_14_32,
    Live_out_14_33,
    Live_out_14_34,
    Live_out_14_35,
    Live_out_15_0,
    Live_out_15_1,
    Live_out_15_2,
    Live_out_15_3,
    Live_out_15_4,
    Live_out_15_5,
    Live_out_15_6,
    Live_out_15_7,
    Live_out_15_8,
    Live_out_15_9,
    Live_out_15_10,
    Live_out_15_11,
    Live_out_15_12,
    Live_out_15_13,
    Live_out_15_14,
    Live_out_15_15,
    Live_out_15_16,
    Live_out_15_17,
    Live_out_15_18,
    Live_out_15_19,
    Live_out_15_20,
    Live_out_15_21,
    Live_out_15_22,
    Live_out_15_23,
    Live_out_15_24,
    Live_out_15_25,
    Live_out_15_26,
    Live_out_15_27,
    Live_out_15_28,
    Live_out_15_29,
    Live_out_15_30,
    Live_out_15_31,
    Live_out_15_32,
    Live_out_15_33,
    Live_out_15_34,
    Live_out_15_35,
    Live_out_16_0,
    Live_out_16_1,
    Live_out_16_2,
    Live_out_16_3,
    Live_out_16_4,
    Live_out_16_5,
    Live_out_16_6,
    Live_out_16_7,
    Live_out_16_8,
    Live_out_16_9,
    Live_out_16_10,
    Live_out_16_11,
    Live_out_16_12,
    Live_out_16_13,
    Live_out_16_14,
    Live_out_16_15,
    Live_out_16_16,
    Live_out_16_17,
    Live_out_16_18,
    Live_out_16_19,
    Live_out_16_20,
    Live_out_16_21,
    Live_out_16_22,
    Live_out_16_23,
    Live_out_16_24,
    Live_out_16_25,
    Live_out_16_26,
    Live_out_16_27,
    Live_out_16_28,
    Live_out_16_29,
    Live_out_16_30,
    Live_out_16_31,
    Live_out_16_32,
    Live_out_16_33,
    Live_out_16_34,
    Live_out_16_35,
    Live_out_17_0,
    Live_out_17_1,
    Live_out_17_2,
    Live_out_17_3,
    Live_out_17_4,
    Live_out_17_5,
    Live_out_17_6,
    Live_out_17_7,
    Live_out_17_8,
    Live_out_17_9,
    Live_out_17_10,
    Live_out_17_11,
    Live_out_17_12,
    Live_out_17_13,
    Live_out_17_14,
    Live_out_17_15,
    Live_out_17_16,
    Live_out_17_17,
    Live_out_17_18,
    Live_out_17_19,
    Live_out_17_20,
    Live_out_17_21,
    Live_out_17_22,
    Live_out_17_23,
    Live_out_17_24,
    Live_out_17_25,
    Live_out_17_26,
    Live_out_17_27,
    Live_out_17_28,
    Live_out_17_29,
    Live_out_17_30,
    Live_out_17_31,
    Live_out_17_32,
    Live_out_17_33,
    Live_out_17_34,
    Live_out_17_35,
    Live_out_18_0,
    Live_out_18_1,
    Live_out_18_2,
    Live_out_18_3,
    Live_out_18_4,
    Live_out_18_5,
    Live_out_18_6,
    Live_out_18_7,
    Live_out_18_8,
    Live_out_18_9,
    Live_out_18_10,
    Live_out_18_11,
    Live_out_18_12,
    Live_out_18_13,
    Live_out_18_14,
    Live_out_18_15,
    Live_out_18_16,
    Live_out_18_17,
    Live_out_18_18,
    Live_out_18_19,
    Live_out_18_20,
    Live_out_18_21,
    Live_out_18_22,
    Live_out_18_23,
    Live_out_18_24,
    Live_out_18_25,
    Live_out_18_26,
    Live_out_18_27,
    Live_out_18_28,
    Live_out_18_29,
    Live_out_18_30,
    Live_out_18_31,
    Live_out_18_32,
    Live_out_18_33,
    Live_out_18_34,
    Live_out_18_35,
    Live_0_0,
    Live_0_1,
    Live_0_2,
    Live_0_3,
    Live_0_4,
    Live_0_5,
    Live_0_6,
    Live_0_7,
    Live_0_8,
    Live_0_9,
    Live_0_10,
    Live_0_11,
    Live_0_12,
    Live_0_13,
    Live_0_14,
    Live_0_15,
    Live_0_16,
    Live_0_17,
    Live_0_18,
    Live_0_19,
    Live_0_20,
    Live_0_21,
    Live_0_22,
    Live_0_23,
    Live_0_24,
    Live_0_25,
    Live_0_26,
    Live_0_27,
    Live_0_28,
    Live_0_29,
    Live_0_30,
    Live_0_31,
    Live_0_32,
    Live_0_33,
    Live_0_34,
    Live_0_35,
    Live_1_0,
    Live_1_1,
    Live_1_2,
    Live_1_3,
    Live_1_4,
    Live_1_5,
    Live_1_6,
    Live_1_7,
    Live_1_8,
    Live_1_9,
    Live_1_10,
    Live_1_11,
    Live_1_12,
    Live_1_13,
    Live_1_14,
    Live_1_15,
    Live_1_16,
    Live_1_17,
    Live_1_18,
    Live_1_19,
    Live_1_20,
    Live_1_21,
    Live_1_22,
    Live_1_23,
    Live_1_24,
    Live_1_25,
    Live_1_26,
    Live_1_27,
    Live_1_28,
    Live_1_29,
    Live_1_30,
    Live_1_31,
    Live_1_32,
    Live_1_33,
    Live_1_34,
    Live_1_35,
    Live_2_0,
    Live_2_1,
    Live_2_2,
    Live_2_3,
    Live_2_4,
    Live_2_5,
    Live_2_6,
    Live_2_7,
    Live_2_8,
    Live_2_9,
    Live_2_10,
    Live_2_11,
    Live_2_12,
    Live_2_13,
    Live_2_14,
    Live_2_15,
    Live_2_16,
    Live_2_17,
    Live_2_18,
    Live_2_19,
    Live_2_20,
    Live_2_21,
    Live_2_22,
    Live_2_23,
    Live_2_24,
    Live_2_25,
    Live_2_26,
    Live_2_27,
    Live_2_28,
    Live_2_29,
    Live_2_30,
    Live_2_31,
    Live_2_32,
    Live_2_33,
    Live_2_34,
    Live_2_35,
    Live_3_0,
    Live_3_1,
    Live_3_2,
    Live_3_3,
    Live_3_4,
    Live_3_5,
    Live_3_6,
    Live_3_7,
    Live_3_8,
    Live_3_9,
    Live_3_10,
    Live_3_11,
    Live_3_12,
    Live_3_13,
    Live_3_14,
    Live_3_15,
    Live_3_16,
    Live_3_17,
    Live_3_18,
    Live_3_19,
    Live_3_20,
    Live_3_21,
    Live_3_22,
    Live_3_23,
    Live_3_24,
    Live_3_25,
    Live_3_26,
    Live_3_27,
    Live_3_28,
    Live_3_29,
    Live_3_30,
    Live_3_31,
    Live_3_32,
    Live_3_33,
    Live_3_34,
    Live_3_35,
    Live_4_0,
    Live_4_1,
    Live_4_2,
    Live_4_3,
    Live_4_4,
    Live_4_5,
    Live_4_6,
    Live_4_7,
    Live_4_8,
    Live_4_9,
    Live_4_10,
    Live_4_11,
    Live_4_12,
    Live_4_13,
    Live_4_14,
    Live_4_15,
    Live_4_16,
    Live_4_17,
    Live_4_18,
    Live_4_19,
    Live_4_20,
    Live_4_21,
    Live_4_22,
    Live_4_23,
    Live_4_24,
    Live_4_25,
    Live_4_26,
    Live_4_27,
    Live_4_28,
    Live_4_29,
    Live_4_30,
    Live_4_31,
    Live_4_32,
    Live_4_33,
    Live_4_34,
    Live_4_35,
    Live_5_0,
    Live_5_1,
    Live_5_2,
    Live_5_3,
    Live_5_4,
    Live_5_5,
    Live_5_6,
    Live_5_7,
    Live_5_8,
    Live_5_9,
    Live_5_10,
    Live_5_11,
    Live_5_12,
    Live_5_13,
    Live_5_14,
    Live_5_15,
    Live_5_16,
    Live_5_17,
    Live_5_18,
    Live_5_19,
    Live_5_20,
    Live_5_21,
    Live_5_22,
    Live_5_23,
    Live_5_24,
    Live_5_25,
    Live_5_26,
    Live_5_27,
    Live_5_28,
    Live_5_29,
    Live_5_30,
    Live_5_31,
    Live_5_32,
    Live_5_33,
    Live_5_34,
    Live_5_35,
    Live_6_0,
    Live_6_1,
    Live_6_2,
    Live_6_3,
    Live_6_4,
    Live_6_5,
    Live_6_6,
    Live_6_7,
    Live_6_8,
    Live_6_9,
    Live_6_10,
    Live_6_11,
    Live_6_12,
    Live_6_13,
    Live_6_14,
    Live_6_15,
    Live_6_16,
    Live_6_17,
    Live_6_18,
    Live_6_19,
    Live_6_20,
    Live_6_21,
    Live_6_22,
    Live_6_23,
    Live_6_24,
    Live_6_25,
    Live_6_26,
    Live_6_27,
    Live_6_28,
    Live_6_29,
    Live_6_30,
    Live_6_31,
    Live_6_32,
    Live_6_33,
    Live_6_34,
    Live_6_35,
    Live_7_0,
    Live_7_1,
    Live_7_2,
    Live_7_3,
    Live_7_4,
    Live_7_5,
    Live_7_6,
    Live_7_7,
    Live_7_8,
    Live_7_9,
    Live_7_10,
    Live_7_11,
    Live_7_12,
    Live_7_13,
    Live_7_14,
    Live_7_15,
    Live_7_16,
    Live_7_17,
    Live_7_18,
    Live_7_19,
    Live_7_20,
    Live_7_21,
    Live_7_22,
    Live_7_23,
    Live_7_24,
    Live_7_25,
    Live_7_26,
    Live_7_27,
    Live_7_28,
    Live_7_29,
    Live_7_30,
    Live_7_31,
    Live_7_32,
    Live_7_33,
    Live_7_34,
    Live_7_35,
    Live_8_0,
    Live_8_1,
    Live_8_2,
    Live_8_3,
    Live_8_4,
    Live_8_5,
    Live_8_6,
    Live_8_7,
    Live_8_8,
    Live_8_9,
    Live_8_10,
    Live_8_11,
    Live_8_12,
    Live_8_13,
    Live_8_14,
    Live_8_15,
    Live_8_16,
    Live_8_17,
    Live_8_18,
    Live_8_19,
    Live_8_20,
    Live_8_21,
    Live_8_22,
    Live_8_23,
    Live_8_24,
    Live_8_25,
    Live_8_26,
    Live_8_27,
    Live_8_28,
    Live_8_29,
    Live_8_30,
    Live_8_31,
    Live_8_32,
    Live_8_33,
    Live_8_34,
    Live_8_35,
    Live_9_0,
    Live_9_1,
    Live_9_2,
    Live_9_3,
    Live_9_4,
    Live_9_5,
    Live_9_6,
    Live_9_7,
    Live_9_8,
    Live_9_9,
    Live_9_10,
    Live_9_11,
    Live_9_12,
    Live_9_13,
    Live_9_14,
    Live_9_15,
    Live_9_16,
    Live_9_17,
    Live_9_18,
    Live_9_19,
    Live_9_20,
    Live_9_21,
    Live_9_22,
    Live_9_23,
    Live_9_24,
    Live_9_25,
    Live_9_26,
    Live_9_27,
    Live_9_28,
    Live_9_29,
    Live_9_30,
    Live_9_31,
    Live_9_32,
    Live_9_33,
    Live_9_34,
    Live_9_35,
    Live_10_0,
    Live_10_1,
    Live_10_2,
    Live_10_3,
    Live_10_4,
    Live_10_5,
    Live_10_6,
    Live_10_7,
    Live_10_8,
    Live_10_9,
    Live_10_10,
    Live_10_11,
    Live_10_12,
    Live_10_13,
    Live_10_14,
    Live_10_15,
    Live_10_16,
    Live_10_17,
    Live_10_18,
    Live_10_19,
    Live_10_20,
    Live_10_21,
    Live_10_22,
    Live_10_23,
    Live_10_24,
    Live_10_25,
    Live_10_26,
    Live_10_27,
    Live_10_28,
    Live_10_29,
    Live_10_30,
    Live_10_31,
    Live_10_32,
    Live_10_33,
    Live_10_34,
    Live_10_35,
    Live_11_0,
    Live_11_1,
    Live_11_2,
    Live_11_3,
    Live_11_4,
    Live_11_5,
    Live_11_6,
    Live_11_7,
    Live_11_8,
    Live_11_9,
    Live_11_10,
    Live_11_11,
    Live_11_12,
    Live_11_13,
    Live_11_14,
    Live_11_15,
    Live_11_16,
    Live_11_17,
    Live_11_18,
    Live_11_19,
    Live_11_20,
    Live_11_21,
    Live_11_22,
    Live_11_23,
    Live_11_24,
    Live_11_25,
    Live_11_26,
    Live_11_27,
    Live_11_28,
    Live_11_29,
    Live_11_30,
    Live_11_31,
    Live_11_32,
    Live_11_33,
    Live_11_34,
    Live_11_35,
    Live_12_0,
    Live_12_1,
    Live_12_2,
    Live_12_3,
    Live_12_4,
    Live_12_5,
    Live_12_6,
    Live_12_7,
    Live_12_8,
    Live_12_9,
    Live_12_10,
    Live_12_11,
    Live_12_12,
    Live_12_13,
    Live_12_14,
    Live_12_15,
    Live_12_16,
    Live_12_17,
    Live_12_18,
    Live_12_19,
    Live_12_20,
    Live_12_21,
    Live_12_22,
    Live_12_23,
    Live_12_24,
    Live_12_25,
    Live_12_26,
    Live_12_27,
    Live_12_28,
    Live_12_29,
    Live_12_30,
    Live_12_31,
    Live_12_32,
    Live_12_33,
    Live_12_34,
    Live_12_35,
    Live_13_0,
    Live_13_1,
    Live_13_2,
    Live_13_3,
    Live_13_4,
    Live_13_5,
    Live_13_6,
    Live_13_7,
    Live_13_8,
    Live_13_9,
    Live_13_10,
    Live_13_11,
    Live_13_12,
    Live_13_13,
    Live_13_14,
    Live_13_15,
    Live_13_16,
    Live_13_17,
    Live_13_18,
    Live_13_19,
    Live_13_20,
    Live_13_21,
    Live_13_22,
    Live_13_23,
    Live_13_24,
    Live_13_25,
    Live_13_26,
    Live_13_27,
    Live_13_28,
    Live_13_29,
    Live_13_30,
    Live_13_31,
    Live_13_32,
    Live_13_33,
    Live_13_34,
    Live_13_35,
    Live_14_0,
    Live_14_1,
    Live_14_2,
    Live_14_3,
    Live_14_4,
    Live_14_5,
    Live_14_6,
    Live_14_7,
    Live_14_8,
    Live_14_9,
    Live_14_10,
    Live_14_11,
    Live_14_12,
    Live_14_13,
    Live_14_14,
    Live_14_15,
    Live_14_16,
    Live_14_17,
    Live_14_18,
    Live_14_19,
    Live_14_20,
    Live_14_21,
    Live_14_22,
    Live_14_23,
    Live_14_24,
    Live_14_25,
    Live_14_26,
    Live_14_27,
    Live_14_28,
    Live_14_29,
    Live_14_30,
    Live_14_31,
    Live_14_32,
    Live_14_33,
    Live_14_34,
    Live_14_35,
    Live_15_0,
    Live_15_1,
    Live_15_2,
    Live_15_3,
    Live_15_4,
    Live_15_5,
    Live_15_6,
    Live_15_7,
    Live_15_8,
    Live_15_9,
    Live_15_10,
    Live_15_11,
    Live_15_12,
    Live_15_13,
    Live_15_14,
    Live_15_15,
    Live_15_16,
    Live_15_17,
    Live_15_18,
    Live_15_19,
    Live_15_20,
    Live_15_21,
    Live_15_22,
    Live_15_23,
    Live_15_24,
    Live_15_25,
    Live_15_26,
    Live_15_27,
    Live_15_28,
    Live_15_29,
    Live_15_30,
    Live_15_31,
    Live_15_32,
    Live_15_33,
    Live_15_34,
    Live_15_35,
    Live_16_0,
    Live_16_1,
    Live_16_2,
    Live_16_3,
    Live_16_4,
    Live_16_5,
    Live_16_6,
    Live_16_7,
    Live_16_8,
    Live_16_9,
    Live_16_10,
    Live_16_11,
    Live_16_12,
    Live_16_13,
    Live_16_14,
    Live_16_15,
    Live_16_16,
    Live_16_17,
    Live_16_18,
    Live_16_19,
    Live_16_20,
    Live_16_21,
    Live_16_22,
    Live_16_23,
    Live_16_24,
    Live_16_25,
    Live_16_26,
    Live_16_27,
    Live_16_28,
    Live_16_29,
    Live_16_30,
    Live_16_31,
    Live_16_32,
    Live_16_33,
    Live_16_34,
    Live_16_35,
    Live_17_0,
    Live_17_1,
    Live_17_2,
    Live_17_3,
    Live_17_4,
    Live_17_5,
    Live_17_6,
    Live_17_7,
    Live_17_8,
    Live_17_9,
    Live_17_10,
    Live_17_11,
    Live_17_12,
    Live_17_13,
    Live_17_14,
    Live_17_15,
    Live_17_16,
    Live_17_17,
    Live_17_18,
    Live_17_19,
    Live_17_20,
    Live_17_21,
    Live_17_22,
    Live_17_23,
    Live_17_24,
    Live_17_25,
    Live_17_26,
    Live_17_27,
    Live_17_28,
    Live_17_29,
    Live_17_30,
    Live_17_31,
    Live_17_32,
    Live_17_33,
    Live_17_34,
    Live_17_35,
    Live_18_0,
    Live_18_1,
    Live_18_2,
    Live_18_3,
    Live_18_4,
    Live_18_5,
    Live_18_6,
    Live_18_7,
    Live_18_8,
    Live_18_9,
    Live_18_10,
    Live_18_11,
    Live_18_12,
    Live_18_13,
    Live_18_14,
    Live_18_15,
    Live_18_16,
    Live_18_17,
    Live_18_18,
    Live_18_19,
    Live_18_20,
    Live_18_21,
    Live_18_22,
    Live_18_23,
    Live_18_24,
    Live_18_25,
    Live_18_26,
    Live_18_27,
    Live_18_28,
    Live_18_29,
    Live_18_30,
    Live_18_31,
    Live_18_32,
    Live_18_33,
    Live_18_34,
    Live_18_35,
    Idle_0,
    Idle_1,
    Idle_2,
    Idle_3,
    Idle_4,
    Idle_5,
    Idle_6,
    Idle_7,
    Idle_8,
    Idle_9,
    Idle_10,
    Idle_11,
    Idle_12,
    Idle_13,
    Idle_14,
    Idle_15,
    Idle_16,
    Idle_17,
    Idle_18,
    Idle_in_0,
    Idle_in_1,
    Idle_in_2,
    Idle_in_3,
    Idle_in_4,
    Idle_in_5,
    Idle_in_6,
    Idle_in_7,
    Idle_in_8,
    Idle_in_9,
    Idle_in_10,
    Idle_in_11,
    Idle_in_12,
    Idle_in_13,
    Idle_in_14,
    Idle_in_15,
    Idle_in_16,
    Idle_in_17,
    Idle_in_18,
    Idle_out_0,
    Idle_out_1,
    Idle_out_2,
    Idle_out_3,
    Idle_out_4,
    Idle_out_5,
    Idle_out_6,
    Idle_out_7,
    Idle_out_8,
    Idle_out_9,
    Idle_out_10,
    Idle_out_11,
    Idle_out_12,
    Idle_out_13,
    Idle_out_14,
    Idle_out_15,
    Idle_out_16,
    Idle_out_17,
    Idle_out_18,
    Reallystale_0,
    Reallystale_1,
    Reallystale_2,
    Reallystale_3,
    Reallystale_4,
    Reallystale_5,
    Reallystale_6,
    Reallystale_7,
    Reallystale_8,
    Reallystale_9,
    Reallystale_10,
    Reallystale_11,
    Reallystale_12,
    Reallystale_13,
    Reallystale_14,
    Reallystale_15,
    Reallystale_16,
    Reallystale_17,
    Reallystale_18,
    Stale_0,
    Stale_1,
    Stale_2,
    Stale_3,
    Stale_4,
    Stale_5,
    Stale_6,
    Stale_7,
    Stale_8,
    Stale_9,
    Stale_10,
    Stale_11,
    Stale_12,
    Stale_13,
    Stale_14,
    Stale_15,
    Stale_16,
    Stale_17,
    Stale_18,
    Stopped_0,
    Stopped_1,
    Stopped_2,
    Stopped_3,
    Stopped_4,
    Stopped_5,
    Stopped_6,
    Stopped_7,
    Stopped_8,
    Stopped_9,
    Stopped_10,
    Stopped_11,
    Stopped_12,
    Stopped_13,
    Stopped_14,
    Stopped_15,
    Stopped_16,
    Stopped_17,
    Stopped_18,
    Stopped_in_0,
    Stopped_in_1,
    Stopped_in_2,
    Stopped_in_3,
    Stopped_in_4,
    Stopped_in_5,
    Stopped_in_6,
    Stopped_in_7,
    Stopped_in_8,
    Stopped_in_9,
    Stopped_in_10,
    Stopped_in_11,
    Stopped_in_12,
    Stopped_in_13,
    Stopped_in_14,
    Stopped_in_15,
    Stopped_in_16,
    Stopped_in_17,
    Stopped_in_18,
    Stopped_out_0,
    Stopped_out_1,
    Stopped_out_2,
    Stopped_out_3,
    Stopped_out_4,
    Stopped_out_5,
    Stopped_out_6,
    Stopped_out_7,
    Stopped_out_8,
    Stopped_out_9,
    Stopped_out_10,
    Stopped_out_11,
    Stopped_out_12,
    Stopped_out_13,
    Stopped_out_14,
    Stopped_out_15,
    Stopped_out_16,
    Stopped_out_17,
    Stopped_out_18,
    ActiveTrafficCamNorth,
    ActiveTrafficCamSouth,
    ActiveTrafficCamEast,
    ActiveTrafficCamWest,
    ActiveTrafficCamNA,
    InactiveTrafficCamNorth,
    InactiveTrafficCamSouth,
    InactiveTrafficCamEast,
    InactiveTrafficCamWest,
    InactiveTrafficCamNA,
    Asset,
    VirtualCamNA,
    VirtualCamNorth,
    VirtualCamEast,
    VirtualCamSouth,
    VirtualCamWest,
    AssetUnlabeled,
    GeofenceIconUnlabled
}

export enum LayerIndex { // in numeric z-order
    Live,
    Trail,
    Crumb,
    Trace,
    Fence,
    Marker,
    OutBorder,
    InBorder,
    SpeedingViolations,
    IdleViolations,
    Events,
    History,
    Trip,
    Address,
    Risk,
    User // user defined layers start here -- always last
}

export enum ZoomIndex { // threshold below which (numerically) layer is invisible
    ZoomedOutEarth = 0,
    Earth = 2,
    Continent,
    Subcontinent,
    MultipleCountry,
    ExtraLargeCountry,
    LargeAfricanCountry,
    LargeEuropeanCountry,
    SmallCountry,
    StateArea,
    LargeMetroArea,
    SmallMetroArea,
    City,
    Town,
    Village,
    Neighborhood,
    Road,
    Highway,
    Block,
    Building
}

export enum ColorIndex {
    C00, C01, C02, C03, C04,
    C05, C06, C07, C08, C09,
    C10, C11, C12, C13, C14,
    C15, C16, C17, C18, C19
}

export enum ShapeType {
    line,
    circle,
    spotlight,
    polygon,
    rectangle = 4
}

export enum MarkerState {
    Add,
    Update,
    Delete
}

interface Object {
    [idx: string]: any;
}
